import { useFeatureEntitlements } from '@frontegg/react';
import { UserOutlined } from '@ant-design/icons';
import { AppNavMenu } from '..';

export const usePatientNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isPatientsModuleEntitled } =
    useFeatureEntitlements('patients-module');

  return isPatientsModuleEntitled
    ? [
        {
          path: '/patients',
          title: 'Patients',
          icon: <UserOutlined />,
        },
      ]
    : [];
};
